import React, { Component } from "react";
import { WindowProgram } from "packard-belle";
import cx from "classnames";
import Window from "../tools/Window";
import * as icons from "../../icons";
import buildMenu from "../../helpers/menuBuilder";

class HtmlWindow extends Component {
  render() {
    const { props } = this;
    const data = props.data || {};
    const iconKey = data.icon || props.iconKey;
    const resolvedIcon = (iconKey && icons[iconKey]) || props.icon;
    return (
      <Window
        {...props}
        title={data.title || props.title || "Window"}
        icon={resolvedIcon}
        menuOptions={buildMenu(props)}
        hasMenu
        Component={WindowProgram}
        className={cx("HtmlWindow", props.className)}
      >
        <div
          style={{
            margin: 0,
            height: "100%",
            minHeight: "100%",
            overflow: "auto",
            background: "#c0c0c0"
          }}
          dangerouslySetInnerHTML={{ __html: data.__html || "" }}
        />
      </Window>
    );
  }
}

export default HtmlWindow;
